import AppConstants from '../config/app.constants';

let CurrencyService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/currency`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/currency/create`, { data })
            .then((res) => {
                return res.data
            })
    };

    let details = (id) => {
        return $http
            .get(AppConstants.api + `/currency/${id}`)
            .then((res) => {
                return res.data
            })
    };

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/currency/${id}`, { data })
            .then((res) => {
                return res.data
            })
    };

    let remove = (id) => {
        return $http
            .delete(AppConstants.api + `/currency/${id}`)
            .then((res) => {
                return res.data
            })
    };

    return {
        all,
        create,
        details,
        update,
        remove
    };

};

CurrencyService.$inject = ['$http', '$q']

export default CurrencyService;


// WEBPACK FOOTER //
// ./client/app/services/currency.service.js